import { Slider } from 'antd';
import style from './style.module.scss';

interface WeatherActivationSliderProps {
    temperatureActivationFloor: number | null | undefined;
    temperatureActivationCeiling: number | null | undefined;
    setFieldValue: (field: string, value: number | null) => void;
}

const marks = {
    '-50': {
        label: <span>-50°C</span>,
    },
    0: {
        label: <span>0°C</span>,
    },
    50: {
        label: <span>50°C</span>,
    },
};

const handleSliderChange = (
    value: [number, number] | number,
    setFieldValue: (field: string, value: number | null) => void
) => {
    if (Array.isArray(value)) {
        setFieldValue('temperatureActivationFloor', value[0]);
        setFieldValue('temperatureActivationCeiling', value[1]);
    }
};

export const WeatherActivationSlider = ({
    temperatureActivationFloor,
    temperatureActivationCeiling,
    setFieldValue,
}: WeatherActivationSliderProps) => {
    return (
        <div className={style.weather_slider}>
            <Slider
                range
                min={-50}
                max={50}
                value={[
                    temperatureActivationFloor ?? -20,
                    temperatureActivationCeiling ?? 30,
                ]}
                onChange={(value) => handleSliderChange(value, setFieldValue)}
                marks={marks}
                tooltip={{
                    formatter: (value?: number) =>
                        typeof value === 'number' ? `${value}°C` : '',
                }}
            />
        </div>
    );
};
